var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4790)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 35.75H23C17.57 35.75 15.25 33.43 15.25 28V22C15.25 16.57 17.57 14.25 23 14.25H29C34.43 14.25 36.75 16.57 36.75 22V28C36.75 33.43 34.43 35.75 29 35.75ZM23 15.75C18.39 15.75 16.75 17.39 16.75 22V28C16.75 32.61 18.39 34.25 23 34.25H29C33.61 34.25 35.25 32.61 35.25 28V22C35.25 17.39 33.61 15.75 29 15.75H23Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5698 29.0201C22.3798 29.0201 22.1898 28.9501 22.0398 28.8001C21.7498 28.5101 21.7498 28.0301 22.0398 27.7401L28.5898 21.1902C28.8798 20.9002 29.3598 20.9002 29.6498 21.1902C29.9398 21.4802 29.9398 21.9602 29.6498 22.2502L23.0998 28.8001C22.9498 28.9501 22.7598 29.0201 22.5698 29.0201Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.98 24.1099C21.89 24.1099 21 23.2199 21 22.1299C21 21.0399 21.89 20.1499 22.98 20.1499C24.07 20.1499 24.96 21.0399 24.96 22.1299C24.96 23.2199 24.07 24.1099 22.98 24.1099ZM22.98 21.6599C22.72 21.6599 22.5 21.8699 22.5 22.1399C22.5 22.4099 22.71 22.6199 22.98 22.6199C23.25 22.6199 23.46 22.4099 23.46 22.1399C23.46 21.8699 23.24 21.6599 22.98 21.6599Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.52 29.8399C28.43 29.8399 27.54 28.9499 27.54 27.8599C27.54 26.7699 28.43 25.8799 29.52 25.8799C30.61 25.8799 31.5 26.7699 31.5 27.8599C31.5 28.9499 30.61 29.8399 29.52 29.8399ZM29.52 27.3899C29.26 27.3899 29.04 27.5999 29.04 27.8699C29.04 28.1399 29.25 28.3499 29.52 28.3499C29.79 28.3499 30 28.1399 30 27.8699C30 27.5999 29.79 27.3899 29.52 27.3899Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4790",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4790"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4790",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimization);
export default __webpack_public_path__ + "static/media/optimization.1e4d17620e09843ba382b8e7676d8589.svg";
export { ForwardRef as ReactComponent };